"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineListPage = void 0;
var MachineList_1 = require("./MachineList");
Object.defineProperty(exports, "MachineListPage", { enumerable: true, get: function () { return MachineList_1.MachineList; } });
